const isValidImage = async (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      if (img.width > 1 && img.height > 1) {
        resolve(true);
      } else {
        resolve(false);
      }
    };
    img.onerror = () => {
      reject(new Error("Failed to load image"));
    };
    img.src = url;
  });
};

const isValidPassword = (password) => {
  return password.length >= 8 &&
    /\d/.test(password) &&
    /[a-zA-Z]/.test(password) &&
    !/[^a-zA-Z0-9!@#$%^&*.]/.test(password);
};

const objectToFormData = (obj) => {
  const formData = new FormData();
  for (const [key, value] of Object.entries(obj)) {
    if (obj[key] !== undefined) {
      formData.append(key, value);
    }
  }
  return formData;
};

const sortEmailsByCreateDate = (emails) => emails.sort((a, b) => {
    const createDateComparison = new Date(a.createDate) - new Date(b.createDate);
    if (createDateComparison !== 0) {
      return createDateComparison;
    }
    return new Date(a.version) - new Date(b.version);
  },
);

export {
  isValidImage,
  isValidPassword,
  objectToFormData,
  sortEmailsByCreateDate,
};